import { RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST, GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_AVAILABLE_TAKA_NO, RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE,
  GET_RAW_MATERIAL_INWARD_CHALLAN_AVAILABLE_TRANSACTIONS } from '../types';

const initialState = {
  availableTransactions: [],
  availableTakaNos: [],
  loading: false,
  error: null,
};

const rawMaterialInwardChallanAvailableTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_RAW_MATERIAL_INWARD_CHALLAN_AVAILABLE_TRANSACTIONS: {
      return {
        ...state,
        availableTransactions: [ ...action.payload ],
        loading: false,
        error: null
      }
    }
    case GET_RAW_MATERIAL_INWARD_CHALLAN_TRANSACTIONS_AVAILABLE_TAKA_NO: {
      return {
        ...state,
        availableTakaNos: [ ...action.payload ],
        loading: false,
        error: null
      }
    }
    case RAW_MATERIAL_INWARD_CHALLAN_TRANSACTION_AVAILABLE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default rawMaterialInwardChallanAvailableTransactionReducer;
